export function getConfigParamsSchema(configVersion) {
    var config_schema;
    switch (configVersion) {
        case 101:
            config_schema = require("../schemas/101/config_params_schema-v101.json");
            break;
        case 102:
            config_schema = require("../schemas/102/config_params_schema-v102.json");
            break;
        case 103:
            config_schema = require("../schemas/103/config_params_schema-v103.json");
            break;
        case 104:
            config_schema = require("../schemas/104/config_params_schema-v104.json");
            break;
        case 105:
            config_schema = require("../schemas/105/config_params_schema-v105.json");
            break;
        case 106:
            config_schema = require("../schemas/106/config_params_schema-v106.json");
            break;
        case 107:
            config_schema = require("../schemas/107/config_params_schema-v107.json");
            break;
        default:
            config_schema = require("../schemas/100/config_params_schema-v100.json");
            break;
    }
    return config_schema;
}
export function getOptionGroupsSchema(configVersion) {
    var options_groups_schema;
    switch (configVersion) {
        case 101:
            options_groups_schema = require("../schemas/101/option_groups_schema-v101.json");
            break;
        case 102:
            options_groups_schema = require("../schemas/102/option_groups_schema-v102.json");
            break;
        case 103:
            options_groups_schema = require("../schemas/103/option_groups_schema-v103.json");
            break;
        case 104:
            options_groups_schema = require("../schemas/104/option_groups_schema-v104.json");
            break;
        case 105:
            options_groups_schema = require("../schemas/105/option_groups_schema-v105.json");
            break;
        case 106:
            options_groups_schema = require("../schemas/106/option_groups_schema-v106.json");
            break;
        case 107:
            options_groups_schema = require("../schemas/107/option_groups_schema-v107.json");
            break;
        default:
            options_groups_schema = require("../schemas/100/option_groups_schema-v100.json");
            break;
    }
    return options_groups_schema;
}
export function getSetupPagesSchema(configVersion) {
    var setup_pages_schema;
    switch (configVersion) {
        case 101:
            setup_pages_schema = require("../schemas/101/setup_pages_schema-v101.json");
            break;
        case 102:
            setup_pages_schema = require("../schemas/102/setup_pages_schema-v102.json");
            break;
        case 103:
            setup_pages_schema = require("../schemas/103/setup_pages_schema-v103.json");
            break;
        case 104:
            setup_pages_schema = require("../schemas/104/setup_pages_schema-v104.json");
            break;
        case 105:
            setup_pages_schema = require("../schemas/105/setup_pages_schema-v105.json");
            break;
        case 106:
            setup_pages_schema = require("../schemas/106/setup_pages_schema-v106.json");
            break;
        case 107:
            setup_pages_schema = require("../schemas/107/setup_pages_schema-v107.json");
            break;
        default:
            setup_pages_schema = require("../schemas/100/setup_pages_schema-v100.json");
            break;
    }
    return setup_pages_schema;
}
export function getConfigRows(configVersion) {
    var config_rows = [];
    var config_rows_v105 = require("../schemas/105/config_rows_v105.js").config_rows_v105;
    var config_rows_v106 = require("../schemas/106/config_rows_v106.js").config_rows_v106;
    var config_rows_v107 = require("../schemas/107/config_rows_v107.js").config_rows_v107;
    if (configVersion === 106) {
        config_rows = config_rows_v106;
    }
    else if (configVersion === 107) {
        config_rows = config_rows_v107;
    }
    else {
        config_rows = config_rows_v105;
    }
    return config_rows;
}
export function getStatisticsSchema(configVersion) {
    var statistics_schema;
    if (configVersion === 105) {
        statistics_schema = require("../schemas/105/statistics_schema-v105.json");
    }
    else if (configVersion === 106) {
        statistics_schema = require("../schemas/106/statistics_schema-v106.json");
    }
    else if (configVersion === 107) {
        statistics_schema = require("../schemas/107/statistics_schema-v107.json");
    }
    return statistics_schema;
}
